import '../stylesheets/application_mypage';

import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';

import 'slick-carousel';
import 'lightbox2';

import './require_react';
import './popup_profile_picture';
import './popup_select';

import './mypage';
import './main';

if(document.body.dataset.member_business_types === "true"){
    import ('./member_business_types');
}